export const getInitialValues = (japCustomer) => {
  return {
    jap_customer_id: japCustomer ?? null,
    text: "",
    task_ids: []
  }
}
